import JEXLService from './JEXLService';
import SpELService from './SpELService';
import { Data, ExpEvalRequest, ExpEvalResult, ExpressionLanguage } from './types';

class ExpService {
  private static instance: ExpService;

  private initialized: boolean = false;
  private language?: ExpressionLanguage;

  private constructor() {}

  static getInstance(): ExpService {
    if (!ExpService.instance) {
      ExpService.instance = new ExpService();
    }
    return ExpService.instance;
  }

  initialize = (language: ExpressionLanguage) => {
    this.language = language;
    this.initialized = true;
  };

  reset = () => {
    this.initialized = false;
    this.language = undefined;
  };

  sizeOf = (data: Data, attribute: string): number => {
    if (!this.initialized) {
      throw new Error(`[ExpService] is not initialized`);
    }
    switch (this.language) {
      case ExpressionLanguage.SPEL:
        return SpELService.sizeOf(data, attribute);
      case ExpressionLanguage.JEXL:
        return JEXLService.sizeOf(data, attribute);
      default:
        throw new Error(`Unsupported expression language: ${this.language}`);
    }
  };

  evaluate = (request: ExpEvalRequest): ExpEvalResult => {
    if (!this.initialized) {
      throw new Error(`[ExpService] is not initialized`);
    }
    switch (this.language) {
      case ExpressionLanguage.SPEL:
        return SpELService.evaluate(request);
      case ExpressionLanguage.JEXL:
        return JEXLService.evaluate(request);
      default:
        throw new Error(`Unsupported expression language: ${this.language}`);
    }
  };

  isInitialized(): boolean {
    return this.initialized;
  }
}

const expService = ExpService.getInstance();

export default expService;
